module.exports = __webpack_public_path__ + "cement/img/蒙版组 125.e7ab486c.png";